/*
 * @Descripttion:
 * @version:
 * @Author: wlk
 * @Date: 2023-11-27 13:33:12
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-13 09:24:47
 */
/*
 * 登录相关接口
 */
import request from '@/service/request'
// import { ILoginParams, IUpdatePwdParams } from '../model'

export default class ajaxAuthService {
  /**
   * 登录
   * @param data
   * @returns
   */
  static login(data: any): Promise<any> {
    return request.post('/staff/login', data)
  }
  /**
   * 退出登录
   * @returns
   */
  static logOut(): Promise<any> {
    return request.get('/staff/webLoginOut')
  }

  /**
   * 获取驿站信息
   * @param data
   * @returns
   */
  static getStationQrCode(): Promise<any> {
    return request.get('/station/stationQrCode')
  }
}
